import { DropdownItemProperties, DropdownProperties } from './properties/dropdown-property.model';

import { ImageProperty } from './properties/image-property.model';
import { TextProperty } from './properties/text-property.model';
import { Widget } from './form-widget.model';
import { BooleanValueProperty } from './properties/boolean-property.model';

export class FbSignatureWidget extends Widget {
  public override title: any = 'Signature';
  public override name: any = 'fb-signature';
  public isProvider: boolean | any;

  get isProviderTypeSignature() {
    return this.properties.signType?.value === '1';
  }

  constructor(data: any = {}, isProvider = false) {
    super(data);
    this.isProvider = isProvider;
    this.properties = this.defaultProperties(data.properties);
  }

  defaultProperties(data: any = {}) {
    const signeeType = this.getSigneeType(data.signType?.value);
    // Compatibility check. Old value was d3 svg lines.

    const properties = {
      id: new TextProperty(
        data.id?.value
          ? data.id
          : {
              title: 'Widget ID',
              value: 'uid' + Math.random().toString(36).substring(2),
            },
      ),
      required: new BooleanValueProperty(data.required || { title: 'Required' }),
      text: new TextProperty({
        value: data.text ? data.text.value : 'Signature',
      }),
      content: new TextProperty(data.content || { title: 'Content' }),
      hint: new TextProperty(data.hint || { title: 'Additional Instruction' }),
      value: new ImageProperty(data.value),
      signType: new DropdownProperties({
        title: data.title ? data.title.value : 'Signature Type',
        value: `${signeeType}`,
        items: [
          new DropdownItemProperties('Client', '2'),
          new DropdownItemProperties('Provider', '1'),
          new DropdownItemProperties('Other', '0'),
        ],
      }),
    };

    properties.signType['signeeName'] = data.signType?.signeeName || '';
    properties.signType['signeeDate'] = data.signType?.signeeDate || '';
    properties.signType['signeeIp'] = data.signType?.signeeIp || '';
    properties.value['original'] = '';

    return properties;
  }

  public getSigneeType(signeeType: any): any {
    switch (signeeType) {
      case 'client':
      case 'witness':
      case '2':
      case 2:
        return '2';
      case 'provider':
      case 'supervisor':
      case 'director':
      case '1':
      case 1:
        return '1';
      case 'other':
      case '0':
      case 0:
        return '0';
      default:
        return '0';
    }
  }

  isValid() {
    if (!this.isRequired()) {
      return true;
    }

    // Required, but can't sign Provider for Client/Other and vice versa
    if (!this.canSign()) {
      return true;
    }

    // Required and has value
    if (this.hasSignature()) {
      return true;
    }

    return false;
  }

  canSign() {
    return true;
    // RESERVED FOR FUTURE USE
    if (this.isProvider && !this.isProviderTypeSignature) {
      return false;
    }

    if (!this.isProvider && this.isProviderTypeSignature) {
      return false;
    }

    return true;
  }
  hasSignature() {
    return (
      this.properties.value.value &&
      this.properties.value.value !==
        'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
    );
  }
}
